var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMilestoneHero3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 267,
    height: 395,
    viewBox: "0 0 267 395",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M146.889 251.506C143.813 240.597 135.729 218.26 114.475 201.307C107.832 196.01 101.216 192.277 95.3433 189.625C83.0977 199.554 70.7515 200.436 67.1192 196.008C64.1026 192.327 66.294 183.998 71.6034 176.262C67.1547 161.562 67.9903 148.604 74.6897 143.881C76.7006 142.467 83.7115 138.638 105.571 151.419C122.835 161.517 153.203 184.217 183.797 238.025",
    fill: "#5B5BD8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M146.889 251.506C143.813 240.597 135.729 218.26 114.475 201.307C107.832 196.01 101.216 192.277 95.3433 189.625C83.0978 199.554 70.7515 200.436 67.1192 196.008C64.1026 192.327 66.294 183.998 71.6034 176.262C67.1547 161.562 67.9903 148.604 74.6897 143.881C76.7006 142.467 83.7115 138.638 105.571 151.419C122.835 161.517 153.203 184.217 183.797 238.025",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0703 166.016C69.5435 159.557 58.6908 158.052 53.9767 161.055C51.8524 162.41 51.0109 164.663 51.3813 166.63C52.3473 171.798 62.0558 177.013 75.7903 178.438",
    fill: "#5B5BD8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0703 166.016C69.5435 159.557 58.6908 158.052 53.9767 161.055C51.8524 162.41 51.0109 164.663 51.3813 166.63C52.3473 171.798 62.0558 177.013 75.7903 178.438",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3824 154.281C82.8541 153.376 81.008 152.426 78.857 151.582C76.0063 150.475 73.399 149.854 71.256 149.491",
    fill: "#5B5BD8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3824 154.281C82.8541 153.376 81.008 152.426 78.857 151.582C76.0063 150.475 73.399 149.854 71.256 149.491",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M262.256 351.717C274.532 356.869 288.66 351.093 293.811 338.817C298.963 326.542 293.188 312.414 280.912 307.262C268.636 302.111 254.508 307.886 249.357 320.162C244.205 332.438 249.98 346.565 262.256 351.717Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M221.198 190.653C225.239 192.859 229.284 195.055 233.325 197.261C241.092 184.434 298.633 90.9323 340.627 98.3333C343.135 98.7761 347.219 99.5587 350.404 102.88C370.549 123.906 315.194 204.932 302.242 223.51C307.226 278.262 282.755 325.875 245.105 340.618C214.224 352.703 181.468 339.933 174.061 337.057C169.573 335.307 134.139 321.047 120.047 293.47C80.231 215.52 227.313 63.0647 275.839 70.3801C278.542 70.7825 285.891 71.8934 288.753 77.1741C294.691 88.1472 275.59 106.639 254.304 136.332C245.289 148.912 233.334 167.043 221.211 190.648L221.198 190.653Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M265.253 190.128C273.169 178.793 282.61 166.547 293.809 153.941C305.895 140.332 317.838 128.78 328.904 119.079",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M185.395 148.977C194.681 138.739 205.59 127.774 218.283 116.681C231.989 104.706 245.293 94.7457 257.493 86.5175",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M119.089 223.29C111.886 240.454 119.961 260.208 137.125 267.411C154.289 274.614 174.043 266.539 181.246 249.374L183.604 243.756C190.807 226.592 182.732 206.838 165.567 199.635C148.403 192.432 128.649 200.508 121.446 217.672L119.089 223.29Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M128.932 248.441C136.663 251.685 146.667 245.41 151.277 234.425C155.887 223.441 153.356 211.906 145.625 208.661C137.894 205.417 127.89 211.692 123.281 222.677C118.671 233.661 121.201 245.196 128.932 248.441Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M131.147 256.409L132.41 238.447L149.411 249.107L131.147 256.409Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M124.546 211.921C126.639 209.019 132.334 201.974 142.248 198.929C154.875 195.048 170.542 198.795 179.466 210.711C190.421 225.342 184.026 242.669 183.603 243.755C163.92 233.145 144.228 222.531 124.546 211.921Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M172.285 244.683C165.082 261.848 173.157 281.601 190.321 288.804C207.486 296.007 227.239 287.932 234.442 270.768L236.8 265.15C244.003 247.985 235.928 228.232 218.764 221.029C201.599 213.826 181.846 221.901 174.643 239.065L172.285 244.683Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M182.127 269.834C189.858 273.079 199.862 266.804 204.472 255.819C209.082 244.834 206.552 233.299 198.821 230.055C191.09 226.811 181.086 233.086 176.476 244.07C171.866 255.055 174.396 266.59 182.127 269.834Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M184.336 277.81L185.603 259.839L202.604 270.499L184.336 277.81Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M177.736 233.312C179.83 230.41 185.525 223.365 195.439 220.32C208.065 216.439 223.732 220.186 232.656 232.102C243.612 246.732 237.216 264.06 236.794 265.146C217.111 254.536 197.419 243.922 177.736 233.312Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M252.526 203.762L227.312 187.745C222.956 184.978 217.182 186.266 214.415 190.622L212.425 193.754C209.658 198.11 210.946 203.884 215.302 206.651L240.516 222.668C244.872 225.435 250.646 224.147 253.413 219.791L255.402 216.659C258.169 212.303 256.881 206.529 252.526 203.762Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M145.803 178.95L174.896 185.723C179.922 186.893 184.944 183.767 186.115 178.742L186.956 175.127C188.126 170.101 185 165.079 179.974 163.908L150.881 157.135C145.855 155.965 140.833 159.091 139.663 164.117L138.821 167.731C137.651 172.757 140.777 177.78 145.803 178.95Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M150.93 281.075C147.34 289.047 150.856 297.551 156.45 299.966C162.606 302.627 172.291 298.332 174.589 288.786C166.702 286.208 158.821 283.644 150.934 281.065L150.93 281.075Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M234.391 288.518C245.615 290.09 269.317 291.678 293.389 279.041C300.912 275.092 306.992 270.537 311.782 266.228C307.62 251.022 311.78 239.365 317.295 237.821C321.879 236.541 328.622 241.898 333.568 249.872C348.815 251.714 360.341 257.693 361.97 265.726C362.455 268.136 363.14 276.095 342.643 290.964C326.452 302.705 293.452 321.373 231.882 327.73",
    fill: "#5B5BD8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M234.391 288.518C245.615 290.09 269.317 291.678 293.389 279.041C300.912 275.092 306.992 270.537 311.782 266.228C307.62 251.022 311.78 239.365 317.295 237.821C321.879 236.541 328.622 241.898 333.568 249.872C348.815 251.714 360.341 257.693 361.97 265.726C362.455 268.136 363.14 276.095 342.643 290.964C326.452 302.705 293.452 321.373 231.882 327.73",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilestoneHero3);
export default __webpack_public_path__ + "static/media/milestone-hero3.0cf84bbd44f8b9ac941e89fd28c9ac65.svg";
export { ForwardRef as ReactComponent };